// src/utils/chartConfig.js
export const colors = [
  '#0582f7',
  '#82d4f5',
  '#e9e9e9',
  '#c6d281',
  '#d89c49',
  '#d65d5d'
]

export const chart = {
  width: null,
  height: null,
  backgroundColor: 'transparent',
  spacingBottom: 0,
  style: {
    fontFamily: 'inherit'
  }
}

export const title = {
  align: 'left',
  margin: 25,
  style: {
    fontWeight: 'normal',
    fontSize: '20px',
    color: '#e9e9e9'
  }
}

export const yAxis = {
  title: { text: '' },
  labels: { style: { color: '#e9e9e9' } },
  gridLineColor: '#3b4f62',
  lineColor: '#3b4f62',
  tickColor: '#3b4f62'
}

export const xAxis = {
  labels: { style: { color: '#e9e9e9' } },
  lineColor: '#3b4f62',
  tickColor: '#3b4f62',
  gridLineColor: '#3b4f62',
  crosshair: {
    color: '#3b4f62'
    // width: 1
  }
}

export const legend = {
  itemStyle: { color: '#e9e9e9', fontWeight: 'normal' },
  itemHoverStyle: { color: '#cccccc' },
  itemHiddenStyle: { color: '#888888' },
  itemMarginTop: 3 // 每個項目上方間距
}

export const plotOptions = {
  column: {
    borderWidth: 0
  },
  candlestick: {
    color: '#82d4f5', // 下跌顏色
    upColor: '#0582f7', // 上漲顏色
    lineColor: '#82d4f5', // 下跌邊線
    upLineColor: '#0582f7' // 上漲邊線
  },
  scatter: {
    marker: {
      radius: 2.5,
      symbol: 'circle'
      // states: {
      //   hover: {
      //     enabled: true,
      //     lineColor: "rgb(100,100,100)",
      //   },
      // },
    },
    jitter: {
      x: 0.005 // 若點重疊, 幫點隨機偏移一點點位置，讓它們不會完全重疊
    }
    // states: {
    //   hover: {
    //     marker: {
    //       enabled: false,
    //     },
    //   },
    // },
  }
}

// chart 統一設定的樣式
export const chartTheme = {
  chart,
  title,
  accessibility: { enabled: false },
  time: {
    timezone: 'Asia/Taipei', // xAxis datetime
    useUTC: false // Deprecated 11.4.2
  },
  lang: { thousandsSep: ',' }, // 千分位符號
  colors,
  tooltip: { valueDecimals: 2, shared: true },
  yAxis,
  xAxis,
  legend,
  credits: { enabled: false },
  plotOptions
}
